export default [
    {
        name: 'foxModel',
        type: 'gltfModel',
        path: 'models/FoxHunter.gltf'
    },
    {
        name: 'foxColorTex',
        type: 'texture',
        path: 'textures/fox_col_1k.jpg'
    },
    {
        name: 'foxShadeTex',
        type: 'texture',
        path: 'textures/fox_shadeMask_1k.jpg'
    },
    {
        name: 'groundModel',
        type: 'gltfModel',
        path: 'models/ground.gltf'
    },
    {
        name: 'groundTex',
        type: 'texture',
        path: 'textures/ground_col_1k.png'
    },
    {
        name: 'plantsModel',
        type: 'gltfModel',
        path: 'models/plants.gltf'
    },
    {
        name: 'plantsTex',
        type: 'texture',
        path: 'textures/plants_col_1k.jpg'
    },
    {
        name: 'backgroundModel',
        type: 'gltfModel',
        path: 'models/sphere.gltf'
    },
    {
        name: 'backgroundTex',
        type: 'texture',
        path: 'textures/bg_col_1k.png'
    },
    {
        name: 'butterflyTex',
        type: 'texture',
        path: 'textures/butterfly.png'
    }
]